module.exports = __webpack_public_path__ + "img/home-4-INTpeople.d8768a46.png";